import React, { useEffect } from "react";
import {  useSelector } from "react-redux";
 
const ThemeProvider = ({ children }) => {
  //   const [theme, setTheme] = useState(
  //     localStorage.getItem("theme") || "light" // Default to light mode
  //   );

  const {theme} = useSelector((store) => store.dashboard);
 
  useEffect(() => {
    // Apply the theme to the root element
    const root = window.document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

 

  return (
    <div>
     
      {children}
    </div>
  );
};

export default ThemeProvider;
